/** Single source of truth for site branding and default document meta. */
export const siteSettings = {
  name: "Wealth Green Firm",
  link: "https://wealthgreenfirm.org",
  email: "support@wealthgreenfirm.org",
  appLink: "https://app.wealthgreenfirm.org",
  tagline: "Trade With Ease",
  description:
    "Modern Trading Firm. Unlock Access to a World of Trading Digital Assets",
  ogImage: "/og-image.png",
};
